import { IDefect } from "../../model/Defect";
import { IDeviceLink } from "../../model/DeviceLink";
import { ITrailer } from "../../model/Trailer";
import { ITrailerAttachment } from "../../model/TrailerAttachment";

export enum CacheActionTypes {
    ADD_CACHE_ENTITY = "ADD_CACHE_ENTITY",
    CLEAR_CACHE = "CLEAR_CACHE",
    CLEAR_ALL_CACHES = "CLEAR_ALL_CACHES",
    CLEAR_ALL_CACHES_FOR_USER = "CLEAR_ALL_CACHES_FOR_USER"
}

export interface ICache {
    user: IIdDictionary<IUser>;
    device: IIdDictionary<IDevice>;
    trailer: IIdDictionary<ITrailer>;
    trailerDevice: IIdDictionary<IDevice>;
    // MYG-148762: trailers cached as Devices under DRIVE.ENABLE_TRAILER_DEVICE_LINK_API.RELEASE.
    // Kept separate from trailerDevice so trailer-cache eviction cannot wipe entries that the DVIR
    // reclassifier and the Inspections hook read.
    trailerAsDevice: IIdDictionary<IDevice>;
    trailerAttachment: IIdDictionary<ITrailerAttachment>;
    deviceLink: IIdDictionary<IDeviceLink>;
    defectList: IIdDictionary<IDefect>;
}

export interface ICacheStore {
    [userId: string]: ICache;
}
